import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';
import { ExpandMoreOutlined } from '@material-ui/icons';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { generateTestId } from '../../../../../../utils';
import PaymentLineItemRateForm from '../../../../../main/apps/ConfiguredApps/payment-line-item-configs/payment-line-item-rate-form/PaymentLineItemRateForm';
import ConfirmationDialog from '../../../../../main/apps/RoleSpecificApps/Admin/user-groups/common/ConfirmationDialog';
import { subcategories } from './select-options';
import EffectiveLineItemRateForm from '../../../../../main/apps/ConfiguredApps/payment-line-item-configs/effective-payment-line-item-rate/EffectiveLineItemRateForm';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const Accordion = withStyles((theme) => ({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        marginBottom: theme.spacing(2),
        minHeight: 56,
    },
    expanded: {},
}))(MuiAccordion);

const AccordionSummary = withStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        minHeight: 56,
        flexGrow: 1,
    },
    expanded: {},
}))(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        display: 'block',
    },
}))(MuiAccordionDetails);

function PaymentLineItemRate({ remove, name }) {
    const [expanded, setExpanded] = useState(true);
    const { getValues } = useFormContext();
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const rateId = getValues(`${name}._id`);
    const canEdit = rateId != null;
    const editPath = `/#/effective-moo-rule-rates/${rateId}`;

    const getAccordionTitle = () => {
        const subcategory = getValues(`${name}.subcategory`);
        const subcategoryLabel = subcategories.find((rt) => rt.id === subcategory)?.name || 'New Rate';
        const rate_name = getValues(`${name}.rate_name`) || '';
        return (
            <span>
                <b>{subcategoryLabel}</b>
                {rate_name && ` - ${rate_name}`}
            </span>
        );
    };
    return (
        <>
            <ConfirmationDialog
                open={showConfirmDialog}
                message="Are you sure you want to remove this rate?"
                onDialogCancelAction={() => setShowConfirmDialog(false)}
                onDialogConfirmAction={remove}
                // wrap
            />
            <Accordion className="mb-16" expanded={expanded} onChange={() => setExpanded(!expanded)}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid rgba(0, 0, 0, .125)' }}>
                    <AccordionSummary expandIcon={<ExpandMoreOutlined data-testid={generateTestId(name, 'accordion-toggle')} />}>{!expanded && getAccordionTitle()}</AccordionSummary>
                    <Box>
                        {canEdit && (
                            <IconButton onClick={() => window.open(editPath, '_blank')}>
                                <Typography variant="caption">Edit</Typography>
                                <ExitToAppIcon sx={{ paddingLeft: '5px' }} />
                            </IconButton>
                        )}
                        <IconButton onClick={() => setShowConfirmDialog(true)} data-testid={generateTestId(name, 'delete-button')}>
                            <CloseIcon color="error" />
                        </IconButton>
                    </Box>
                </Box>
                <AccordionDetails>
                    <PaymentLineItemRateForm name={name} setShowConfirmDialog={setShowConfirmDialog} disabledOnEdit={canEdit} />
                    <EffectiveLineItemRateForm name={name} disabledOnEdit={canEdit} />
                </AccordionDetails>
            </Accordion>
        </>
    );
}

export default PaymentLineItemRate;
